export default __webpack_public_path__ + "images/0x5979d7b546e38e414f7e9822514be443a4800529.png";